import React, { createContext, useContext } from "react";
import { User, Home, Package, CreditCard, Coins, Settings, LogOut } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Button } from "./ui/button";

// サイトタイプを Context で提供（App.tsx で Provider を設定）
export const SiteTypeContext = createContext<'oripa' | 'kuji' | undefined>(undefined);
export const useSiteType = () => useContext(SiteTypeContext);

const UserSidebar: React.FC = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const siteType = useSiteType();

  // ポイントのラベルはサイトタイプで変更
  const pointLabel = siteType === 'kuji' ? 'ポイント管理' : 'ポイント購入';

  const baseMenuItems = [
    { path: "/profile", icon: User, label: "マイページ" },
    { path: "/home-address", icon: Home, label: "お届け先住所" },
    { path: "/products", icon: Package, label: "獲得した商品" },
    { path: "/point", icon: Coins, label: pointLabel },
  ];

  // くじの場合は支払い方法メニューを追加
  const kujiMenuItems = siteType === 'kuji'
    ? [{ path: "/payment-methods", icon: CreditCard, label: "お支払い方法" }]
    : [];

  const menuItems = [
    ...baseMenuItems,
    ...kujiMenuItems,
    { path: "/settings", icon: Settings, label: "設定" },
  ];

  return (
    <aside className="w-64 bg-white border-4 border-black rounded-xl shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] p-4">
      <h2 className="text-lg font-black text-black mb-4 px-2">マイページ</h2>
      <nav>
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <li key={item.path}>
                <a
                  href={item.path}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all border-2 ${
                    isActive
                      ? "bg-theme-primary border-black text-theme-button font-bold shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]"
                      : "border-transparent text-gray-700 font-bold hover:bg-gray-100 hover:border-black"
                  }`}
                >
                  <Icon size={18} />
                  <span className="text-sm">{item.label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* ログアウトボタン */}
      <div className="mt-6 pt-4 border-t-2 border-black">
        <button
          onClick={logout}
          className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-white border-2 border-black rounded-lg font-bold text-red-600 shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] hover:shadow-[1px_1px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[1px] hover:translate-y-[1px] hover:bg-red-50 transition-all"
        >
          <LogOut size={18} />
          <span className="text-sm">ログアウト</span>
        </button>
      </div>
    </aside>
  );
};

export default UserSidebar;
